// extracted by mini-css-extract-plugin
export default {"colorFilterSelect":"ColorSwatch_colorFilterSelect__P5Fbh","colorSwatch":"ColorSwatch_colorSwatch__cFfai","insideColorSwatch":"ColorSwatch_insideColorSwatch__hnePB"};